import { salesPartnerSettings } from '@e2m-customer-portal/core';
import {
  useFeatureFlags,
  useSalesPartnerConfiguredMutation,
  useSalesPartnersAsConfiguredMutation,
  useSnackbar,
} from '@e2m-customer-portal/hooks';
import { SalesPartner, SalesPartnerGroup } from 'generated/graphql';
import { ReactElement } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { Dialog } from '../dialog/Dialog';

export interface JammerBannerProps {
  salesPartners: Array<SalesPartner | SalesPartnerGroup>;
  open?: boolean;
}

export const JammerBanner = ({
  salesPartners,
  open = false,
}: Readonly<JammerBannerProps>): ReactElement<JammerBannerProps> => {
  const [t] = useTranslation();
  const { useNewSalesPartnerAPI } = useFeatureFlags();
  const [setConfigured] = useNewSalesPartnerAPI
    ? useSalesPartnersAsConfiguredMutation((salesPartners as Array<SalesPartner>).map((sp) => sp.contractPartnerNumber))
    : useSalesPartnerConfiguredMutation();
  const { showError } = useSnackbar();

  const updateConfig = (): void => {
    setConfigured().catch(() => showError(t('SHARED_ERROR_UNKNOWN')));
  };

  return (
    <Dialog
      className="jammer-banner"
      open={open}
      actions={
        <Link
          className="flex w-full items-center justify-center rounded bg-green-200 px-4 py-2 text-sm font-semibold text-white no-underline"
          to={salesPartnerSettings.getLink()}
          onClick={updateConfig}
        >
          {t('JAMMER_BANNER_ACTION')}
        </Link>
      }
    >
      <div className="p-2">
        <header>
          <h3 className="m-0 pb-4 text-xl leading-6">{t('JAMMER_BANNER_TITLE')}</h3>
        </header>
        <div className="py-2 text-sm">
          <Trans components={{ ul: <ul />, li: <li />, span: <span className="text-grey-400"></span> }}>
            {t('JAMMER_BANNER_DESCRIPTION', {
              names: salesPartners
                .map((sp) => sp.name)
                .map((name) => `<li><strong>${name}</strong></li>`)
                .join(''),
            })}
          </Trans>
        </div>
      </div>
    </Dialog>
  );
};
